module.exports = __webpack_public_path__ + "img/cover.9c9e1097.webp";